import ResetPassword from 'components/pages/ResetPassword/ResetPassword';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login');
export default buildPage(ResetPassword, {
  metaData: {
    title: 'Password reset',
    description: 'Reset your password',
  },
});
